/* eslint-disable @typescript-eslint/no-unnecessary-condition */
// eslint-disable-next-line local-rules/enforce-filename-and-named-export
import { UserConst } from '@axiom/const';
import type { User } from '@axiom/validation';

export const isLpUser = (user?: User | null) =>
  !!user?.roles?.includes(UserConst.Roles.LPUser);
export const isSalesUser = (user?: User | null) =>
  !!user?.roles?.includes(UserConst.Roles.EnvoySales);
export const isEnvoyAdmin = (user?: User | null) =>
  !!user?.roles?.includes(UserConst.Roles.EnvoyAdmin);
export const isEnvoyUser = (user?: User | null) =>
  !!user?.roles?.includes(UserConst.Roles.EnvoyUser);
export const isClientUser = (user?: User | null) =>
  !!user?.roles?.includes(UserConst.Roles.ClientUser);
export const isBoomiUser = (user?: User | null) =>
  !!user?.roles?.includes(UserConst.Roles.BoomiSync);
export const isAfcUser = (user?: User | null) =>
  !!(user?.roles && (isEnvoyAdmin(user) || isClientUser(user)));
export const isAhqUser = (user?: User | null) =>
  !!(
    user?.roles &&
    (isEnvoyAdmin(user) || isEnvoyUser(user) || isSalesUser(user))
  );
